import { useState } from "react";
import Modal from "../../../../parts/modal-new";
import ModalFooter from "../../../../parts/modals/ModalFooter";
import {
  getFrequencyString,
  getIntervalString,
  getMinimumTermLength,
} from "../../../../utils/stripe-helpers";
import Select from "../../../../parts/inputs/select";

export const MinimumTerm = ({ plan = {} }) => {
  const { id, recurring, metadata } = plan;
  const termPeriod = metadata?.minimum_term;
  const intervalString = getIntervalString(recurring);
  const minimumPeriodLength = getMinimumTermLength(intervalString);

  const [agreement, setAgreement] = useState(!!termPeriod);
  const [hasMinimumTerm, setHasMinimumTerm] = useState(!!termPeriod);
  const [minimumTermPeriod, setMinimumTermPeriod] = useState(termPeriod || 1);

  return (
    <Modal
      className="plan-modal trial min-term"
      toClear={["plan", "type"]}
      title={`Edit ${intervalString} plan`}
    >
      <form
        className="body"
        action="/actions/plan-manager/add-minimum-term"
        method="POST"
        data-noreset
        id="add-minimum-term"
      >
        <input type="hidden" name="id" value={id} />
        <div className="modal-body">
          <div className="row">
            <div className="group">
              <label className="label" htmlFor="switch">
                Add minimum term (optional)
              </label>

              <input
                type="checkbox"
                id="switch"
                role="switch"
                name="hasMinimumTerm"
                checked={hasMinimumTerm}
                onChange={() => setHasMinimumTerm((state) => !state)}
              />
            </div>
          </div>
          <div className="row">
            <div className="group">
              <Select
                title="Minimum period"
                name="minimum_term"
                id="minimum_term"
                value={minimumTermPeriod}
                disabled={!hasMinimumTerm}
                onChange={(val) => setMinimumTermPeriod(val)}
                options={Array.from({ length: minimumPeriodLength }, (v, i) => {
                  return {
                    text: i + 1,
                    value: i + 1,
                  };
                })}
              />
            </div>
          </div>

          {hasMinimumTerm && (
            <span className="chip warning">
              Subscribers will not be able to cancel their subscription until{" "}
              {minimumTermPeriod}{" "}
              {getFrequencyString(recurring, minimumTermPeriod)} has passed
            </span>
          )}

          {hasMinimumTerm && (
            <div className="flex items-center gap-2 mt-6">
              <input
                type="checkbox"
                id="agreement"
                name="agreeToMinimumTerm"
                checked={agreement}
                onChange={() => setAgreement((state) => !state)}
              />
              <label htmlFor="agreement">
                I confirm that I want to add a minimum term commitment to my{" "}
                {plan?.nickname || intervalString} subscription plan
              </label>
            </div>
          )}
        </div>
      </form>
      <ModalFooter
        isSubmitButton
        showAltButton={false}
        onClickButton={(e) => {}}
        classNameButton="button save"
        disabled={!agreement && hasMinimumTerm}
        formId="add-minimum-term"
      />
    </Modal>
  );
};
